module.exports = __webpack_public_path__ + "static/img/3.72ffdfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/3.png
// module id = U4rD
// module chunks = 0